// extracted by mini-css-extract-plugin
module.exports = {"page":"_tenant__page__OzKfK","page-body":"_tenant__page-body__aPb6s","header":"_tenant__header__19QLm","header-description":"_tenant__header-description__vcBuD"};